import { FaThumbsDown } from "react-icons/fa"
import Styles from '../styles/SuccessOrError.module.css'

export const Error = (props) => {
    return(
        <div className={Styles.error}>
            <p className={Styles.items}>{props.name}</p>
            <FaThumbsDown  className={Styles.items}/>
        </div>
    )
}